var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M0 0h32v32H0z","key":0}),React.createElement("path",{"d":"M11.447 27v-8.566H9v-4.895h2.447v-2.421A6.118 6.118 0 0117.566 5h3.671v4.895H18.79a2.446 2.446 0 00-2.448 2.447v1.197h4.895l-1.224 4.895h-3.671V27h-4.895z","fill":"currentColor","fillRule":"nonzero","key":1})]));
}

Facebook.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = Facebook;

Facebook.default = Facebook;
